import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

import HexCard from "../../../../../components/HexCard";
import HexLoader from "../../../../../components/HexLoader";

import { getLabel } from "../../../../../hooks/use-labels";

import { reserveOrder } from "../../../../../redux/reducers/order/order-action";
import HexButton from "../../../../../ui-kit/HexButtons";
import {
  getErrorCode,
  getStorageItem,
  handleError,
  setStorageItem,
  showErrorNotification,
} from "../../../../../utils/common-utils";

import {
  canProceedCart,
  getOrderInfoRequest,
  saveOrderDetails,
} from "../cart-details-utils";
import MessageModal from "../../../../../components/HexModal/MessageModal";

import { RESERVATION_EXPIRY_MINUTES } from "../../../../../utils/constants";
import ProductUpdatedModal from "../../Components/ProductUpdatedModal";

const ProceedButtonCard = ({
  cartItems,
  summary,
  moveToCart,
  payableAmount,
  makeFreePayment,
}) => {
  const canProceed = canProceedCart(cartItems);
  const freePayment = payableAmount && payableAmount.value === 0;

  const [loading, setLoading] = useState(false);
  const [updateProductModal, setUpdateProductModal] = useState(false);
  const [messageModal, setMessageModal] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const moveToPaymentPage = () => {
    navigate("/order/payment", {
      state: {
        link: {
          path: "/my-cart/summary",
          previousState: { ...location.state },
        },
      },
    });
  };

  const moveToSummary = () => {
    navigate("/my-cart/summary", {
      state: { link: { path: "/my-cart" } },
    });
  };

  const showProductModal = () => {
    setUpdateProductModal((prev) => !prev);
  };

  const reserveOrderDetails = () => {
    const orderRequest = getOrderInfoRequest();
    setLoading(true);
    reserveOrder(orderRequest)
      .then(({ data }) => {
        const { id, orderInfo } = data;
        const storedOrder = getStorageItem("orderInfo");
        setLoading(false);

        if (
          storedOrder &&
          orderInfo.payableAmount.value !== storedOrder.payableAmount.value
        ) {
          showProductModal();
        } else {
          setStorageItem("reservationInfo", {
            reservationId: id,
            orderInfo,
            reservationExpiry: moment().add(
              RESERVATION_EXPIRY_MINUTES,
              "minutes"
            ),
          });

          if (freePayment) {
            makeFreePayment();
          } else {
            moveToPaymentPage();
          }
        }
      })
      .catch((error) => {
        const code = getErrorCode(error);
        const message = handleError(error);

        if (code === "cart.empty") {
          setMessageModal(true);
        } else {
          showErrorNotification({ title: "", body: message });
        }

        setLoading(false);
      });
  };

  const setOrderInfo = () => {
    setLoading(true);

    saveOrderDetails({
      successCB: () => {
        setLoading(false);
        moveToSummary();
      },
      errorCB: ({ message, code }) => {
        if (code === "cart.empty") {
          setMessageModal(true);
        } else {
          showErrorNotification({ title: "", body: message });
        }
        setLoading(false);
      },
    });
  };

  const onProceed = () => {
    if (summary) {
      reserveOrderDetails();
    } else {
      setOrderInfo();
    }
  };

  const getButtonLabel = () => {
    let buttonLabel = getLabel("proceedLabel");

    if (summary && freePayment) buttonLabel = getLabel("placeOrderLabel");
    else if (summary) buttonLabel = getLabel("proceedToPaymentLabel");

    return buttonLabel;
  };

  return (
    <HexCard className={"last-card content-card"}>
      {messageModal && <ProductUpdatedModal />}

      {updateProductModal && (
        <MessageModal
          open={true}
          title={getLabel("productUpdatedLabel")}
          text={getLabel("productCartUpdatedMessage")}
          onOkay={moveToCart}
          className={"cart-limit-modal"}
        />
      )}

      {loading && <HexLoader />}

      <HexButton
        label={getButtonLabel()}
        disable={!canProceed || loading}
        onClick={onProceed}
        type="primary"
        size="md"
        htmlType="submit"
        className="full-width address-save-button"
      />
    </HexCard>
  );
};

export default ProceedButtonCard;
